if (!customElements.get('collection-preview-menu')) {
  customElements.define('collection-preview-menu', class extends HTMLElement {
    connectedCallback() {
      this.images = this.querySelector('.collection-preview__images');
      this.cache = new Map();
      this.request = 0;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.defaultLink = this.querySelector('[data-preview-link]');
      this.querySelectorAll('[data-preview-link]').forEach((link) => {
        link.addEventListener('pointerenter', () => this.preview(link), options);
        link.addEventListener('pointerleave', () => this.preview(this.defaultLink), options);
        link.addEventListener('focus', () => this.preview(link), options);
        link.addEventListener('blur', () => this.preview(this.defaultLink), options);
      });
      this.dropdown = this.closest('.main-nav__item--dropdown');
      this.isOpen = false;
      const syncOpenState = () => {
        const isOpen = this.dropdown.classList.contains('is-open') && !this.dropdown.classList.contains('is-closing');
        if (isOpen === this.isOpen) return;
        this.isOpen = isOpen;
        if (isOpen) this.preview(this.defaultLink);
        else this.clear();
      };
      this.observer = new MutationObserver(syncOpenState);
      if (this.dropdown) {
        this.observer.observe(this.dropdown, { attributes: true, attributeFilter: ['class'] });
        syncOpenState();
      }
    }

    clear() {
      this.request += 1;
      this.images.querySelectorAll('.is-active').forEach((image) => image.classList.remove('is-active'));
    }

    async preview(link) {
      if (!this.isOpen || !link || !window.matchMedia('(min-width: 769px)').matches) return;
      const request = ++this.request;
      const template = link.parentElement.querySelector('template');
      if (!template) {
        this.clear();
        return;
      }
      let image = this.cache.get(template);
      if (!image) {
        image = template.content.firstElementChild.cloneNode(true);
        this.cache.set(template, image);
        this.images.append(image);
      }
      try {
        await image.decode();
      } catch {
        if (request === this.request) this.clear();
        return;
      }
      if (request !== this.request || !this.isConnected) return;
      requestAnimationFrame(() => {
        if (request !== this.request) return;
        this.images.querySelectorAll('.is-active').forEach((current) => current.classList.remove('is-active'));
        image.classList.add('is-active');
      });
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      this.request += 1;
    }
  });
}
